import { render } from "./theme35.vue?vue&type=template&id=2b9f717a&scoped=true"
import script from "./theme35.vue?vue&type=script&lang=js"
export * from "./theme35.vue?vue&type=script&lang=js"

import "./theme35.vue?vue&type=style&index=0&id=2b9f717a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2b9f717a"

export default script